import { atom } from "jotai";
import { INotification } from "library/types";

export const panelIsOpenState = atom(false);

export const notificationMessagesState = atom<INotification[] | []>([]);

export const darkModeState = atom(false);

// User roles from JWT token
export const userRolesState = atom<string[]>([]);

// User info from token and API
export interface UserInfo {
  roles: string[];
  email?: string;
  name?: string;
  userId?: string;
  exp?: number;
  // Additional fields from GET /user/info API
  userEmail?: string;
  userFullName?: string;
  userPhoneNumber?: string;
}

export const userInfoState = atom<UserInfo | null>(null);
